// import {LoginResult} from '@/interfaces/User';
import {Module} from 'vuex';
import { getAllUsersUnsecured } from '@/services/UsersServices'
import { UserRoleEnum } from '@/enums/userRolesEnum';

interface UserState {
  loggedInUser?: LoginResult;
}

interface User {
  appUserId: number;
  firstName: string;
  lastName: string;
}

interface LoginResult {
  token: string;
  tokenExpiration: number;
  user: {
    userId: number;
    email: string;
    firstName: string;
    lastName: string;
    roles: number[];
  };
}

export default {
  namespaced: true,
  state: {
    loggedInUser: undefined,
    lastRoute: '',
    users: []
  },
  getters: {
    // If the logged in user has any of the roles passed in in the array, pass as true
    hasRole: (state: any) => (roleToVerify: Array<UserRoleEnum>) => {
      for (let i = 0; i < roleToVerify.length; i++) {
        if (state.loggedInUser && state.loggedInUser.user && state.loggedInUser.user.roles) {
          for (let si = 0; si < state.loggedInUser.user.roles.length; si++) {
            // If the user is of role Admin, they have unlimited access to the system.
            if (state.loggedInUser.user.roles[si] === UserRoleEnum.ADMIN || state.loggedInUser.user.roles[si] === roleToVerify[i]) {
              return true;
            }
          }
        }
      }
      return false;
    },
    isTokenExpired: (state: any) => () => {
      return state.loggedInUser.tokenExpiration < new Date();
    },
    getLastRoute (state: any) {
      return state.lastRoute;
    },
    getUserById: (state: any) => (userId: number): User | undefined => {
      return state.users.filter( ( usr: User) => {
        if (usr.appUserId === userId) {
          return usr;
        }
      }).pop();
    }
  },
  actions: {
    isLoggedIn({commit, state}): boolean {
      return Boolean(state.loggedInUser);
    },
    async loadUsers( {commit, state}: any ) {
      const users = await getAllUsersUnsecured();
      commit('setUsers', users);
    }
  },
  mutations: {
    setLogin(state, payload: LoginResult) {
      state.loggedInUser = payload;
      let parsedToken = JSON.parse(atob(payload.token.split('.')[1]));
      state.loggedInUser.tokenExpiration = parsedToken.exp * 1000;
    },
    setLogout(state) {
      state.loggedInUser = undefined;
    },
    setLastRoute (state: any, from: any) {
      state.lastRoute = from;
    },
    setUsers (state: any, payload: User[]) {
      state.users = payload;
    }
  },
} as Module<UserState, any>;
